import * as React from "react";
import { connect } from "react-redux";
import { useRoute } from "react-router5";
import { ProducTab, ProductTabs } from "~/apps/pos/consts";
import { Features, UserRole } from "~/apps/shared/consts";
import Tabs from "~/common/controls/Tabs";
import { navigate } from "~/router";

const ProductsHeaderTabs = ({ information, userRole }) => {
  const { route } = useRoute();
  
  if (userRole !== UserRole.AGENT) return null;

  const isCategoriesTabEnabled = information.entities.features?.includes(Features.TRANSACTION_DATA_EXPOSED);
  
  const tabs = ProductTabs.options()
    .filter((option) => isCategoriesTabEnabled || option.key !== ProducTab.CATEGORIES)
    .map((option) => {
      return {
        ...option,
        isActive: route.name.startsWith(option.route),
        onClick: () => {
          navigate(option.route);
        },
      };
    });

  return <Tabs tabsToDisplay={tabs} />;
};

const mapStateToProps = (state) => {
  return {
    information: state.shared.information,
    userRole: state.shared.auth.currentUser.role,
  };
};

export default connect(mapStateToProps)(ProductsHeaderTabs);
